"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubFrequenceTransactionCorporation = void 0;
exports.ESubFrequenceTransactionCorporation = {
    mensuelle: "mensuelle",
    trimestrielle: "trimestrielle",
    annuelle: "annuelle",
    annuelle_supereur: "annuelle_supereur",
};
